const en = {
    path: '',
    name: 'English',
    shorthand: 'en',
}

export default en
